import { Component, OnInit, HostListener } from "@angular/core";
import { Router } from '@angular/router';
import { Consultant } from "../../../models/Consultant.model";
import { ConsultantService } from "../../../services/consultant.service";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { Json2csvService } from "../../../services/json2csv.service";
import * as moment from 'moment';
import * as _ from 'lodash';
import { ConsultantFilterFactory } from "../../../shared/factories/consultants/filters.factory";
import { LocalStorage } from "../../../shared/wrappers/LocalStorage";
import { UrlBuilderFactory } from "../../../shared/factories/url-builder.factory";
import { ToastsManager } from "ng2-toastr";
import { GUARDS } from '../../../shared/auth/Roles';
import { BankService } from '../../../services/bank.service';
import { DropDownList } from '../../../models/DropDownList.model';

interface CustomerType {
    _id?: string
    end: string
    start: string
    name: string
}

@Component({
    selector: "app-consultants",
    templateUrl: "./consultants-report.component.html",
    styleUrls: ["./consultants-report.component.css"]
})
export class ConsultantsReportComponent implements OnInit {

    filters = {
        active: { list: [], options: null, selected: [] },
        kind: { list: [], options: null, selected: [] },
        responsible: { list: [], options: null, selected: [] },
        division: { list: [], options: null, selected: [] },
        name: null,
        email:null,
        month: { list: [], selected: null },
        monthend: { list: [], selected: null },
        limit: { list: [5, 10, 50, 100], selected: 10 },
        year: { list: [], selected: null },
        yearend: { list: [], selected: null },
        industry: { list: [], options: null, selected: [] },
        excellenceCenter: { list: [], options: null, selected: [] },
        supportCenter: { list: [], options: null, selected: [] },
        additivePending: { list: [], options: null, selected: [] },
        skip: 0,
        additiveCompanyChangePending: null,
        additiveValueAdjustmentPending: null,
    };

    consultants: Consultant[];
    banks;
    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 0;
    skip:number = 0;
    limit:number = 10;
    loading:boolean;
    outputPersonal:boolean = false;
    outputContract:boolean = false;
    outputAdditiveHistory:boolean = false;
    outputPayment: boolean = false;
    outputContact: boolean = false;
    currentSkip;
    currentLimit;
    occupations = [];
    user;
    canShow: boolean = false;
    isUserAdm2: boolean = false;
    isUserInfra: boolean = false;
    isUserGovernance: boolean = false;
    isUserCommercial: boolean = false;
    isUserDP: boolean = false;
    isUserFinances: boolean = false;
    isUserAccounting: boolean = false;
    isUserPeople = false;
    dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();
    privateCategory = [GUARDS.JUDICIARY, GUARDS.GOVERNANCE, GUARDS.MANAGER, GUARDS.COMMERCIAL, GUARDS.ADMINISTRATIVE];

    constructor(
        private consultantService: ConsultantService,
        private json2csvService: Json2csvService,
        private commonHelper:CommonHelper,
        private consultantFiltersFactory: ConsultantFilterFactory,
        private localStorage:LocalStorage,
        private queryStringFactory: UrlBuilderFactory,
        private toastr: ToastsManager,
        private bankService: BankService
    ) {}

    async ngOnInit() {
        this.user = this.localStorage.retrieve('user');
        this.checkPermissions();

        if (this.privateCategory.includes(this.user.permission))
            this.canShow = true;

        this.filters = await this.consultantFiltersFactory.build(this.filters);
        this.occupations = await this.consultantService.getAllContractProfile();
        this.banks = await this.bankService.getBanks();

        this.searchConsultants();
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.searchConsultants(1);
        }

    }

    async searchConsultants(page?: number) {
        this.loading = true;
        this.currentPage = page ? page : 1;
        this.filters.limit.selected = this.filters.limit.selected === 0 ? 10 : this.filters.limit.selected;
        const res = await this.consultantService.getAll(this.queryStringFactory.build(this.loadFilters(page)));
        this.totalItems = res.metadata["totalItems"];
        this.consultants = res.data;
        this.loading = false;
    }

    saveFilters() {
        this.localStorage.save(this.loadFilters(), 'consultants');
    }

    loadFilters(page?) {
        this.currentPage = page ? page : (this.currentPage ? this.currentPage : 1);

        let filters = {};

        _.forOwn(this.filters, (value, key) => {
            const selected = _.get(value, 'selected', value);
            if (selected == 'undefined' || selected == null) return;

            filters[key] = selected;
            filters[key] = _.isArray(filters[key]) ? filters[key].map(item => _.get(item, 'id')) : filters[key];
        });

        delete filters['additivePending'];
        delete filters['additiveValueAdjustmentPending'];
        delete filters['additiveCompanyChangePending'];
        if (this.filters.additivePending.selected.length) {
            if (this.filters.additivePending.selected.find((additive) => additive.id === 1))
                filters['additiveValueAdjustmentPending'] = true
            if (this.filters.additivePending.selected.find((additive) => additive.id === 3))
                filters['additiveCompanyChangePending'] = true
        }

        return {
            ...filters,
            limit: this.filters.limit.selected,
            skip: (this.currentPage - 1) * this.filters.limit.selected
        };
    }

    async export() {
        this.loading = true;
        this.currentSkip = this.filters.skip;
        this.currentLimit = this.filters.limit.selected;
        this.filters.skip = 0;
        this.currentLimit = this.filters.limit.selected = 0;
        const res = await this.consultantService.getAll(this.queryStringFactory.build(this.loadFilters(1)));

        if(this.outputContract){
            this.occupations = await this.consultantService.getAllContractProfile();
        }

        let consultantsExport = [];

        consultantsExport = res.data.map(consultant => {
            let isUserDPAndCLT = this.isUserDP && consultant.contract.kind != 1;
            let exportObject = this.setExport(consultant);

            let format = this.setFormat(consultant,exportObject);

            if(this.outputPersonal && (this.canShow || isUserDPAndCLT || this.isUserPeople)){
                format = this.addPersonal(format,exportObject,consultant);
            }

            if(this.outputContract){
               format = this.addContract(format,exportObject,consultant);
            }

            if(this.outputPayment && (this.canShow || isUserDPAndCLT || this.isUserFinances || this.isUserAccounting || this.isUserPeople)){
                format = this.addPayment(format,consultant);
            }

            if(this.outputContact && (this.canShow || isUserDPAndCLT || this.isUserPeople)){
                format = this.addContact(format,exportObject,consultant);
            }

            if(this.isUserInfra){
                format = this.addInfraDatas(format,consultant);
            }

            if(this.isUserAdm2){
                format = this.addAdm2Datas(format, consultant);
            }

            if(this.isUserFinances || this.isUserAccounting || this.isUserPeople){
                format = this.addFinancesData(format, exportObject,consultant)
            }

            if(this.isUserGovernance)
                format['Data_Criação_Registro'] = consultant.created ? moment(consultant.created).utc().format("DD/MM/YYYY") : '-'

            return format;
        });

        if(this.outputContract && this.outputAdditiveHistory){
            consultantsExport = this.addAdditivesHistory(consultantsExport);
        }

        this.json2csvService.export(
            consultantsExport,
            `relatório de consultores - ${new Date().toLocaleDateString('pt-br')}`
        );

        this.filters.skip = this.currentSkip;
        this.filters.limit.selected = this.currentLimit;
        this.loading = false;
        this.toastr.success('Exportação de consultores realizada com sucesso.');
    }

    getStatus(status){
        switch (status){
            case false:
                return "Inativo";
            case true:
                return "Ativo";
        }
    }

    setFormat(consultant,exportObject){
        return {
            "Name": consultant.name?consultant.name:"-",
            "Email_Omnik": consultant.fcEmail?consultant.fcEmail:"-",
            "Responsible": consultant.responsible.name?consultant.responsible.name:'-',
            "Business_Partner": consultant.bp&&consultant.bp.name?consultant.bp.name:'-',
            "Sexo_do_Consultor": this.transcriptSex(consultant.personal.sex),
            "Status":exportObject.status?exportObject.status:"-",
            "Divisao":exportObject.group?exportObject.group:"-",
            'Centro_de_Excelencia': consultant.excellenceCenter && consultant.excellenceCenter.name ? consultant.excellenceCenter.name : "-",
            'Área_de_Suporte': consultant.supportCenter && consultant.supportCenter.name ? consultant.supportCenter.name : "-",
        };
    }

    transcriptSex(sexCode){
        switch(sexCode){
            case '1': return 'Feminino';
            case '2': return 'Masculino';
            case '3': return 'Não Binário';
            case '4': return 'Prefere Não Informar';
            default: return '-';
        }
    }

    transcriptCustomerName(customerName: CustomerType){
        if(customerName.end == null){
            return `${customerName.name}`;
        }
    }

    setExport(exportObject){
        return  {
            kind : this.commonHelper.transcriptContractType(exportObject.contract.kind),
            hono : this.commonHelper.transcriptHonorariumType(exportObject.contract.honorarium),
            group : this.commonHelper.transcriptDivisionGroup(exportObject.division),
            status : this.getStatus(exportObject.active),
            born : exportObject.personal.born ? moment(exportObject.personal.born).utc().format("DD/MM/YYYY") : "-",
            civilStatus : exportObject.personal.civilStatus?this.commonHelper.transcriptCivilStatus(exportObject.personal.civilStatus):'-',
            begin : exportObject.contract.begin ? moment(exportObject.contract.begin).utc().format("DD/MM/YYYY") : "-",
            end : exportObject.contract.end ? moment(exportObject.contract.end).utc().format("DD/MM/YYYY") : "-",
            paymentType : exportObject.contract.paymentType? this.commonHelper.transcriptPaymentType(exportObject.contract.paymentType):'-',
            contractStatus : exportObject.contract.contractStatus? this.commonHelper.transcriptContractStatus(exportObject.contract.contractStatus):'-',
            contactType : exportObject.emergency.type? this.commonHelper.transcriptContactType(exportObject.emergency.type):'-',
            partnership : exportObject.contract.partnership?this.commonHelper.transcriptPartnershipType(exportObject.contract.partnership):'-'
        };
    }

    addPersonal(format,exportObject,consultant){
        format['Email'] = consultant.email ? consultant.email : '-';
        format['RG'] = consultant.personal.rg?consultant.personal.rg:'-';
        format['CPF'] = consultant.personal.cpf?consultant.personal.cpf:'-';
        format['Nome_Mae'] = consultant.personal.motherName?consultant.personal.motherName:'-';
        format['Nome_Pai'] = consultant.personal.fatherName?consultant.personal.fatherName:'-';
        format['Termo_Confidencial_Gerado'] = consultant.generatedConfidentiality?'Sim':'Não';
        format['Dado_Apenas_Para_Controle_Interno_De_Quem_NÃO_Assinou'] = consultant.acceptedTerm?'Sim':'Não';
        format['Data_Nascimento'] = exportObject.born;
        format['Estado_Civil'] = exportObject.civilStatus;
        format['Telefone'] = consultant.personal.homePhone?consultant.personal.homePhone:'-';
        format['Celular'] = consultant.personal.cellPhone?consultant.personal.cellPhone:'-';
        format['Consultor_CEP'] = consultant.personal.cep?consultant.personal.cep:'-';
        format['Consultor_Endereco'] = consultant.personal.address?consultant.personal.address:'-';
        format['Consultor_Numero'] = consultant.personal.number?consultant.personal.number:'-';
        format['Consultor_Complemento'] = consultant.personal.complement?consultant.personal.complement:'-';
        format['Consultor_Bairro'] = consultant.personal.district?consultant.personal.district:'-';
        format['Consultor_Cidade'] = consultant.personal.city?consultant.personal.city:'-';
        format['Consultor_Estado'] = consultant.personal.state && consultant.personal.state != 0 ? consultant.personal.state:'-';
        format['Consultor_Pais'] = consultant.personal.country?consultant.personal.country:'-';

        return format;
    }

    addContract(format,exportObject,consultant){
        let isUserDPAndCLT = this.isUserDP && consultant.contract.kind != 1;

        const flatCustomer = consultant.contract.customers && consultant.contract.customers.map((ch: CustomerType) => this.transcriptCustomerName(ch))
            .filter((item: string) => typeof item === 'string');

        if(this.outputAdditiveHistory && (this.canShow || isUserDPAndCLT)) {
            format['Aditivo_Situacao'] = 'Vigente no contrato';
            format['Aditivo_Tipo'] = 'Vigente no contrato';
            format['Aditivo_Pendente'] = 'Vigente no contrato';
            format['Aditivo_Data'] = 'Vigente no contrato';
        }

        if(this.canShow || isUserDPAndCLT || this.isUserPeople) {
            format['Contrato_Inicio'] = exportObject.begin;
            format['Contrato_Fim'] = exportObject.end;
            format['Contrato_Tipo'] = exportObject.kind?exportObject.kind:"-";
            format['Honorario'] = exportObject.hono?exportObject.hono:"-"; // 1 = aberto / 2 = fechado
            format['Pagamento_Tipo'] = exportObject.paymentType?exportObject.paymentType:'-';
            format['Total_Valor'] = consultant.contract.totalValue?consultant.contract.totalValue.toLocaleString("pt-BR"):'-';
            format['Horas_Mensais'] = consultant.contract.mensalHours?consultant.contract.mensalHours.toLocaleString("pt-BR"):'-'; // horas mensais de contrato
            format['Custo_Total_Provisões_e_Benefícios'] = consultant.contract.totalCostWithBenefits?consultant.contract.totalCostWithBenefits.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
            format['Valor_Hora'] = consultant.contract.hourValue?consultant.contract.hourValue.toLocaleString("pt-BR"):'-';
            format['Valor_Horas_vendidas'] = consultant.contract.soldHourValue?consultant.contract.soldHourValue.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
            format['Beneficios'] = consultant.contract.benefits?consultant.contract.benefits:'-';
            format['Parceria_Contabil'] = exportObject.partnership; //rational, etc
            format['Parceria_Contabil_Obs'] = consultant.contract.partnershipObs?consultant.contract.partnershipObs:'-'; //comentarios
            format['Contrato_Status'] = exportObject.contractStatus;
            format['CPOM'] = consultant.contract.cpom?consultant.contract.cpom:'-';
            format['ISS'] = consultant.contract.iss?consultant.contract.iss:'-';
            format['IRRF'] = consultant.contract.irrf?consultant.contract.irrf:'-';
            format['PCC'] = consultant.contract.pcc?consultant.contract.pcc:'-';
            format['Contrato_Gerado'] = consultant.contract.generated?'Sim':'Não';
            format['Contrato_Nota'] = consultant.contract.borrowedNote?this.commonHelper.transcriptBorrowNote(parseInt(consultant.contract.borrowedNote)):'-';
            format['Alocacao'] = consultant.contract.allocation?this.commonHelper.transcriptAllocationType(consultant.contract.allocation):'-';
            format['Clientes'] = consultant.contract.customers&&consultant.contract.customers.length>0 ? flatCustomer.join(' | '):'-';
            format['Classificacao'] = consultant.contract.classification?this.commonHelper.transcriptContractClassification(consultant.contract.classification):'-';
            format['Skills'] = consultant.skills&&consultant.skills.length>0?consultant.skills.map(sk => sk.name).join(', '):'-';
            format['Contrato_Regime'] = consultant.contract.taxRegime?consultant.contract.taxRegime:'-';
            format['Motivo_Saida'] = consultant.contract.termination?this.commonHelper.transcriptLeaveType(consultant.contract.termination.leaveType):'-';
            format['Observacoes'] = consultant.contract.termination?consultant.contract.termination.observation:'-';
            format['Laptop_Devolvido'] = consultant.contract.termination?consultant.contract.termination.laptopReturned?'Sim':'Não':'-';
            format['Acordo_Devolucao'] = consultant.contract.termination?consultant.contract.termination.returnAgreement?'Sim':'Não':'-';
            format['Descricao_Acordo'] = consultant.contract.termination?consultant.contract.termination.descReturnAgreement?consultant.contract.termination.descReturnAgreement:'-':'-';
            format['additive_history'] = this.outputAdditiveHistory && consultant.contract.additivesHistory ? consultant.contract.additivesHistory : [];
            format['Laptop_Com_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopReturned?consultant.contract.termination.laptopHasBreakdown?'Sim':'Não':'-';
            format['Valor_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValue?consultant.contract.termination.damageValue:'-':'-';
            format['Descrição_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValueObservation?consultant.contract.termination.damageValueObservation:'-':'-';
        }

        format['Razao_Social'] = consultant.contract.companyName?consultant.contract.companyName:'-';
        format['CNPJ'] = consultant.contract.cnpj?consultant.contract.cnpj:'-';
        format['Empresa_CEP'] = consultant.contract.cep?consultant.contract.cep:'-';
        format['Empresa_Endereco'] = consultant.contract.address?consultant.contract.address:'-';
        format['Empresa_Numero'] = consultant.contract.number?consultant.contract.number:'-';
        format['Empresa_Bairro'] = consultant.contract.district?consultant.contract.district:'-';
        format['Empresa_Cidade'] = consultant.contract.city?consultant.contract.city:'-';
        format['Empresa_Estado'] = consultant.contract.state?consultant.contract.state:'-';
        format['Cargo'] = consultant.contract.position?this.commonHelper.transcriptPositionType(consultant.contract.position):'-';
        format['Perfil'] = consultant.contract.occupation?(this.occupations.find(occ => occ.code == consultant.contract.occupation) || {}).name:'-';

        return format;
    }

    addPayment(format,consultant){
        format['Pagamento_Banco'] = (consultant.payment && consultant.payment.bank)?this.commonHelper.transcriptBank(consultant.payment.bank):'-';
        format['Pagamento_Agencia'] = (consultant.payment && consultant.payment.agency)?consultant.payment.agency:'-';
        format['Pagamento_Conta'] = (consultant.payment && consultant.payment.account)?consultant.payment.account:'-';
        format['Pagamento_Digito'] = (consultant.payment && consultant.payment.digit)?consultant.payment.digit:'-';
        format['Pagamento_Tipo_Pix'] = consultant.payment && consultant.payment.typePix?this.commonHelper.transcriptPixType(consultant.payment.typePix):'-';
        format['Pagamento_Chave_Pix'] = consultant.payment && consultant.payment.keyPix?consultant.payment.keyPix : '-';
        return format;
    }

    addContact(format,exportObject,consultant){
        format['Emergency_Contact_Type'] = exportObject.contactType; // quem é o contato
        format['Emergency_Contact_Name'] = consultant.emergency.name? consultant.emergency.name:'-';
        format['Emergency_Contact_Phone'] = consultant.emergency.phone? consultant.emergency.phone:'-';

        return format;
    }

    addInfraDatas(format,consultant){
        format['CPF'] = consultant.personal.cpf?consultant.personal.cpf:'-';
        format['Laptop_Devolvido'] = consultant.contract.termination?consultant.contract.termination.laptopReturned?'Sim':'Não':'-';
        format['Acordo_Devolucao'] = consultant.contract.termination?consultant.contract.termination.returnAgreement?'Sim':'Não':'-';
        format['Descricao_Acordo'] = consultant.contract.termination?consultant.contract.termination.descReturnAgreement?consultant.contract.termination.descReturnAgreement:'-':'-';
        format['Laptop_Com_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopReturned?consultant.contract.termination.laptopHasBreakdown?'Sim':'Não':'-';
        format['Valor_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValue?consultant.contract.termination.damageValue:'-':'-';
        format['Descrição_Avarias'] = consultant.contract.termination&&consultant.contract.termination.laptopHasBreakdown?consultant.contract.termination.damageValueObservation?consultant.contract.termination.damageValueObservation:'-':'-';
        return format;
    }

    addAdm2Datas(format, consultant){
        format['Telefone'] = consultant.personal.homePhone?consultant.personal.homePhone:'-';
        format['Celular'] = consultant.personal.cellPhone?consultant.personal.cellPhone:'-';
        format['Consultor_CEP'] = consultant.personal.cep?consultant.personal.cep:'-';
        format['Consultor_Endereco'] = consultant.personal.address?consultant.personal.address:'-';
        format['Consultor_Numero'] = consultant.personal.number?consultant.personal.number:'-';
        format['Consultor_Complemento'] = consultant.personal.complement?consultant.personal.complement:'-';
        format['Consultor_Bairro'] = consultant.personal.district?consultant.personal.district:'-';
        format['Consultor_Cidade'] = consultant.personal.city?consultant.personal.city:'-';
        format['Consultor_Estado'] = consultant.personal.state?consultant.personal.state:'-';
        return format;
    }

    addFinancesData(format, exportObject, consultant){
        format['Contrato_Tipo'] = exportObject.kind?exportObject.kind:"-";
        format['Alocacao'] = consultant.contract.allocation?this.commonHelper.transcriptAllocationType(consultant.contract.allocation):'-';
        format['Custo_Total_Provisões_e_Benefícios'] = consultant.contract.totalCostWithBenefits?consultant.contract.totalCostWithBenefits.toLocaleString("pt-BR"):'-'; //valor das horas vendidas
        format["Data_Saída"] = consultant.consultantEnd ? moment(consultant.consultantEnd).utc().format("DD/MM/YYYY") : "-";
        return format
    }

    addAdditivesHistory(consultants) {
        let dataExport = [];
        consultants.forEach(consultant => {
            let isUserDPAndCLT = this.isUserDP && consultant['Contrato_Tipo'] != 'PJ';
            if(consultant.additive_history.length > 0) {
                dataExport.push(consultant);

                consultant.additive_history.forEach(additive => {
                    let additiveOld = {};

                    _.forOwn(consultant, (value, key) => {
                        additiveOld[key] = value;
                    });

                    if (this.canShow || isUserDPAndCLT) {
                        const pendingStatus = additive.pendingGovApproval && additive.pendingApproval ? 'Governança/Jurídico' :
                                              additive.pendingGovApproval ? 'Governança' : additive.pendingApproval ? 'Jurídico' : 'Não';

                        additiveOld['Aditivo_Situacao'] = 'Log do histórico de aditivos';
                        additiveOld['Aditivo_Tipo'] = additive.additiveType == '1' ? 'Reajuste de valor' :
                                                      additive.additiveType == '2' ? 'Renovação de contrato' :
                                                      additive.additiveType == '3' ? 'Alteração de Razão Social/CNPJ' : '###';
                        additiveOld['Aditivo_Pendente'] = pendingStatus;
                        additiveOld['Aditivo_Data'] = additive.date ? moment(additive.date).utc().format("DD/MM/YYYY") : '-';
                        additiveOld['Honorario'] = this.commonHelper.transcriptHonorariumType(additive.honorarium);
                        additiveOld['Total_Valor'] = additive.totalValue ? additive.totalValue.toLocaleString("pt-BR") : '-';
                        additiveOld['Horas_Mensais'] = additive.mensalHours ? additive.mensalHours.toLocaleString("pt-BR") : '-';
                        additiveOld['Valor_Horas_vendidas'] = additive.soldHourValue ? additive.soldHourValue.toLocaleString("pt-BR") : '-';
                        additiveOld['Valor_Hora'] = additive.hourValue ? additive.hourValue.toLocaleString("pt-BR") : '-';
                    }

                    additiveOld['Razao_Social'] = additive.oldCompanyName ? additive.oldCompanyName : '-' ;
                    additiveOld['CNPJ'] = additive.oldCnpj ? additive.oldCnpj : '-' ;
                    additiveOld['Empresa_CEP'] = additive.oldCompanyCep ? additive.oldCompanyCep : '-' ;
                    additiveOld['Empresa_Endereco'] = additive.oldCompanyAddress ? additive.oldCompanyAddress : '-' ;
                    additiveOld['Empresa_Numero'] = additive.oldCompanyNumber ? additive.oldCompanyNumber : '-' ;
                    additiveOld['Empresa_Bairro'] = additive.oldCompanyDistrict ? additive.oldCompanyDistrict : '-' ;
                    additiveOld['Empresa_Cidade'] = additive.oldCompanyCity ? additive.oldCompanyCity : '-' ;
                    additiveOld['Empresa_Estado'] = additive.oldCompanyState ? additive.oldCompanyState : '-' ;

                    //Mantém array de contratos apenas na 1º posição p/ evitar duplicidade Adt X Cont
                    additiveOld['contract_history'] = [];

                    delete additiveOld['additive_history'];

                    dataExport.push(additiveOld);
                });
                delete consultant.additive_history;
            } else {
                delete consultant.additive_history;
                dataExport.push(consultant);
            }
        });
        return dataExport;
    }

    findOccupation(occupation: number) {
        if (occupation) {
            const foundOccupation = this.occupations.find(occ => occ.code == occupation);
            return foundOccupation != undefined ? foundOccupation.name : '-'
        }
        return '-'
    }

    transcriptBank(bankCode: string){
        const bank = this.banks.find(b => b.bankCode === bankCode);
        if(bank)
            return bank.name;
        return '';
    }

    checkPermissions(){
        if(this.user.permission == GUARDS.INFRA)
            this.isUserInfra = true;
        else if(this.user.permission == GUARDS.ADMINISTRATIVE_2)
            this.isUserAdm2 = true;
        else if(this.user.permission == GUARDS.GOVERNANCE)
            this.isUserGovernance = true;
        else if(this.user.permission == GUARDS.COMMERCIAL)
            this.isUserCommercial = true;
        else if(this.user.permission == GUARDS.DP)
            this.isUserDP = true;
        else if(this.user.permission == GUARDS.FINANCES)
            this.isUserFinances = true;
        else if(this.user.permission == GUARDS.ACCOUNTING)
            this.isUserAccounting = true;
        this.isUserPeople = this.user.permission == GUARDS.PEOPLE;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/reports/consultants-report/consultants-report.component.ts